import React from 'react';
import {
  useCurrentProject,
  useProjectsProvider,
} from '@material-bank/projects-utils';
import { useIntl } from 'react-intl';
import { Button, ArrowPushDownIcon } from '../../../../../../../UILibrary';
import { definedTranslation } from '../../../i18n';
import { ChangeProjectDropDown } from '../../ChangeProjectDropDown';

type PreviewFilesActionsProps = {
  isSelectingFiles: boolean;
  isDownloadDisabled?: boolean;
  totalFilesChecked: number;
  downloadClickHandler: () => void;
  onSelectFile: () => void;
  onCancelSelect: () => void;
};

export function PreviewFilesActions({
  isSelectingFiles,
  isDownloadDisabled,
  totalFilesChecked,
  onSelectFile,
  downloadClickHandler,
  onCancelSelect,
}: PreviewFilesActionsProps) {
  const intl = useIntl();
  const { activeProjects } = useProjectsProvider();
  const { currentProject, setCurrentProjectId } = useCurrentProject();

  return (
    <div className="sticky flex flex-col gap-2 p-6 bottom-0">
      {isSelectingFiles ? (
        <>
          <ChangeProjectDropDown
            showSelectedProject
            projects={activeProjects}
            currentProject={currentProject}
            onProjectChange={(projectId) => {
              setCurrentProjectId(projectId);
            }}
            openDirection="top"
          />
          <Button
            variant="primary"
            onClick={downloadClickHandler}
            disabled={totalFilesChecked === 0}
          >
            <ArrowPushDownIcon />{' '}
            {totalFilesChecked > 1
              ? intl?.formatMessage(
                  definedTranslation.previewFiles.downloadFilesBtn,
                )
              : intl?.formatMessage(
                  definedTranslation.previewFiles.downloadFileBtn,
                )}
          </Button>
          <Button variant="secondary" onClick={onCancelSelect}>
            {intl?.formatMessage(definedTranslation.previewFiles.cancelBtn)}
          </Button>
        </>
      ) : (
        <>
          <ChangeProjectDropDown
            showSelectedProject={true}
            projects={activeProjects}
            currentProject={currentProject}
            onProjectChange={(projectId) => {
              setCurrentProjectId(projectId);
            }}
            openDirection="top"
          />

          <Button
            variant="primary"
            disabled={isDownloadDisabled}
            onClick={downloadClickHandler}
          >
            <ArrowPushDownIcon />{' '}
            {intl?.formatMessage(
              definedTranslation.previewFiles.downloadFileBtn,
            )}
          </Button>
          <Button variant="secondary" onClick={onSelectFile}>
            {intl?.formatMessage(
              definedTranslation.previewFiles.selectFilesBtn,
            )}
          </Button>
        </>
      )}
    </div>
  );
}
